import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type EditType } from '../types';
import META from './useTrackAssetEditGenerated.meta';

export type UseTrackAssetEditGeneratedParams = {
  edit_type: EditType;
  size_width: number;
  size_height: number;
  crop_preset?: string;
};

export const useTrackAssetEditGenerated = () => {
  const { track } = useAnalyticsUtilities();

  const trackAssetEditGenerated = useCallback(
    (params: UseTrackAssetEditGeneratedParams) => {
      track(META.name, {
        ...params,
        category: 'asset_details',
      });
    },
    [track],
  );

  return { trackAssetEditGenerated };
};
